/**
 * 主站前台 - 关于我们
 * 路由: /about
 * 数据源: GET /api/cms/pages/about
 */

import { useState, useEffect } from 'react';
import api from '../services/api';

export default function About() {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPage();
  }, []);

  const loadPage = async () => {
    try {
      const response = await api.get('/cms/pages/about');
      setPage(response.data.page);
    } catch (error) {
      console.error('加载页面失败:', error);
    } finally {
      setLoading(false);
    }
  };

  // 从JSONB提取HTML
  const extractHtml = (content) => {
    if (!content) return '';
    if (typeof content === 'string') return content;
    if (typeof content === 'object' && content.html) return content.html;
    return '';
  };

  const contentHtml = page ? extractHtml(page.content) : '';

  return (
    <div className="pt-24 pb-20 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 页头 */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">关于我们</h1>
        </div>

        {/* 内容区 */}
        {loading ? (
          <div className="text-center py-20">
            <div className="inline-block w-8 h-8 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : contentHtml ? (
          <article
            className="prose prose-invert prose-lg max-w-none
              prose-headings:text-white prose-headings:font-bold
              prose-p:text-gray-300 prose-p:leading-relaxed
              prose-a:text-blue-400
              prose-strong:text-white
              prose-blockquote:border-blue-500 prose-blockquote:text-gray-400
              prose-img:rounded-lg"
            dangerouslySetInnerHTML={{ __html: contentHtml }}
          />
        ) : (
          <div className="text-center py-20">
            <div className="text-6xl mb-6 opacity-20">🏢</div>
            <h2 className="text-2xl font-bold text-white mb-3">DND Platform</h2>
            <p className="text-gray-400 max-w-lg mx-auto">
              零代码建站平台，让产品经理独立完成网站全生命周期开发。
              无需技术团队，无需编写代码，从设计到上线一站式完成。
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
